import React from "react";
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import { Box, Container } from "@mui/material";
import GalleryShowcase from "./GalleryShowcase";
import GalleryBanner from "./GalleryBanner";
import { galleryData } from "./GalleryData";

const GalleryHomePage = () => {
  return (
    <>
      <Header />
      <Box sx={{ backgroundColor: "#ffff" }}>
        <GalleryBanner />
        <Container>
          <GalleryShowcase /> {/* REMOVE ALL PROPS */}
        </Container>
      </Box>
      <Footer variant="light" />
    </>
  );
};

export default GalleryHomePage;